import { render, staticRenderFns } from "./RecommendationActions.vue?vue&type=template&id=77ee24d8&scoped=true"
import script from "./RecommendationActions.vue?vue&type=script&lang=ts"
export * from "./RecommendationActions.vue?vue&type=script&lang=ts"
import style0 from "./RecommendationActions.vue?vue&type=style&index=0&id=77ee24d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ee24d8",
  null
  
)

export default component.exports